import React, { useState, useRef, useEffect } from "react";
import "./CustomDropDown.scoped.scss";
import { ImageScale } from "interfaces/sw/SWInterfaces";

type Option = {
  label: string;
  value: ImageScale;
};

interface CustomDropdownProps {
  options: ImageScale[];
  onSelect: (option: ImageScale) => void;
  currentValue: ImageScale;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ options, onSelect, currentValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<ImageScale>(currentValue);
  const dropdownRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option: ImageScale) => {
    setSelected(option);
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <div className="dropdown" ref={dropdownRef} title="Scale the image">
      <div className="dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>
        { selected }
        <span className="arrow">▲</span>
      </div>

      {isOpen && (
        <ul className="dropdown-menu">
          {options.map((option) => (
            <li
              key={option}
              className="dropdown-item"
              onClick={() => handleSelect(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
